import type { IconProps } from "./icon-types";

/**
 * 반시계 방향 회전/초기화. ZoomPan view reset 등에서 사용.
 *
 * 글리프는 Lucide `rotate-ccw`를 인라인으로 재현한다. c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않으므로 공용 UI glyph로 둔다.
 */
export const RotateCcwIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <g transform="translate(0.5 0)">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
    </g>
  </svg>
);
